import Viewer from './Viewer.view';

export default Viewer;
